function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_232",
  "data-name": "Group 232",
  transform: "translate(30.975)"
}, React.createElement("circle", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(-20.475 5.5)",
  fill: "#606060"
}), React.createElement("path", {
  id: "Path_259",
  "data-name": "Path 259",
  d: "M-18.475,25a12.5,12.5,0,0,1-12.5-12.5A12.5,12.5,0,0,1-18.475,0a12.5,12.5,0,0,1,12.5,12.5,12.465,12.465,0,0,1-5.106,10.068l-.017.015,0,0,0,0h0a1.512,1.512,0,0,1-2.1-.371,1.511,1.511,0,0,1,.354-2.094h0A9.461,9.461,0,0,0-8.975,12.5a9.511,9.511,0,0,0-9.5-9.5,9.511,9.511,0,0,0-9.5,9.5,9.511,9.511,0,0,0,9.5,9.5,9.478,9.478,0,0,0,2-.216",
  fill: "#606060"
}), React.createElement("path", {
  id: "Path_247",
  "data-name": "Path 247",
  d: "M-16.475,23V13.587a1.968,1.968,0,0,0-1.9-1.9c-.07-.007-.14-.01-.21-.01a1.9,1.9,0,0,0-1.89,1.91V23.1a2.014,2.014,0,0,0,2.1,1.9A1.988,1.988,0,0,0-16.475,23Z",
  fill: "#606060"
}));

var SvgAbout = function SvgAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/about.fa57b371.svg";
export { ForwardRef as ReactComponent };